import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import SampleTypeWriteDTO from '../../../../../../types/sample-type/SampleTypeWriteDTO';
import { SampleTypeService } from '../../../../services/sample-type.service';

@Component({
    selector: 'app-create-sample-type-dialog',
    templateUrl: './create-sample-type-dialog.component.html',
    styleUrls: [ './create-sample-type-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        InputNumber,
        Textarea,
    ]
})
export class CreateSampleTypeDialogComponent {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() sampleTypeCreated: EventEmitter<SampleTypeWriteDTO> = new EventEmitter<SampleTypeWriteDTO>();

    constructor(private sampleTypeService: SampleTypeService,
                private messageService: MessageService) {
    }

    public sampleType: SampleTypeWriteDTO = new SampleTypeWriteDTO({});

    public loading = false;

    get saveDisabled(): boolean {
        return !this.sampleType.name;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveSampleType() {
        this.loading = true;
        this.sampleTypeService.createSampleType(this.sampleType).then(() => {
            this.sampleTypeCreated.emit(this.sampleType);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.sampleType = new SampleTypeWriteDTO({});
            this.loading = false;
        });
    }
}
